module.exports = __webpack_public_path__ + "static/media/MississippiState-WeRingTrue-500x250-Animated.1f0eceb3.mp4";